import PropTypes from 'prop-types';
import React from 'react';
import { range } from 'lodash';
import classNames from 'classnames';
import SvgIcon from './SvgIcon';

const StepProgress = ({
    stepsCount,
    currentStepIndex,
    completedStepIndex,
}) => stepsCount ? (
    <div aria-hidden="true" className="step-progress">
        <div className="progress-track" />
        <ul className="progress">
            {range(stepsCount).map(index => (
                <li
                    key={`step-${index}`}
                    className={classNames('progress-step', { active: index <= currentStepIndex })}
                >
                    {index <= completedStepIndex &&
                        (
                            <SvgIcon
                                ariaLabelledBy="Checkmark"
                                ariaDescribedBy="Check icon"
                                class="svg-check lantern-svg"
                                id="check"
                            />
                        )}
                </li>
            ))}
        </ul>
    </div>
) : null;

StepProgress.propTypes = {
    stepsCount: PropTypes.number.isRequired,
    currentStepIndex: PropTypes.number,
    completedStepIndex: PropTypes.number,
};

StepProgress.defaultProps = {
    currentStepIndex: -1,
    completedStepIndex: -1,
};

export default StepProgress;
